var _path, _path2, _path3, _circle, _path4, _path5, _use, _use2, _use3, _use4, _use5, _use6, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 600,
    viewBox: "0 0 500 300",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h500v300H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#007a5e",
    d: "M42 42h416v216H42z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 42h416L42 258h416z",
    fill: "#fcd116"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 36,
    cy: 150,
    cx: 250,
    fill: "#ce1126"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.944 150.113c4.262 8.515 12.757 17.893 20.313 21.321.367-8.513-2.341-19.515-6.224-28.33z",
    fill: "#ce1126"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.284 121.487c6.35 13.695-17.533 45.856 21.453 53.976-4.736-6.643-7.33-17.752-6.04-26.456 8.095 3.448 16.212 11.464 19.402 18.972 13.444-37.484-26.456-33.922-34.815-46.492z",
    fill: "#fcd116"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#fcd116"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 100,
    fill: "#fcd116"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 200,
    fill: "#fcd116"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 200,
    y: -258,
    fill: "#fcd116"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 100,
    y: -258,
    fill: "#fcd116"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    y: -258,
    fill: "#fcd116"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m250 117-19.397 59.697 50.782-36.895h-62.769l50.782 36.895z",
    fill: "#fcd116"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m150 259.5-11.462 35.276 30.007-21.802h-37.091l30.007 21.802z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGd);
export default __webpack_public_path__ + "static/media/gd.57da7ed5203d85eacaf25bc47ff9e498.svg";
export { ForwardRef as ReactComponent };